(function () {
  'use strict';

  function initialize() {
    var mobile = window.matchMedia('(max-width: 1023px)');

    document.querySelectorAll('body.template-product .single-product .grid').forEach(function (grid) {
      if (grid.dataset.biossProductOrderReady) return;
      var aside = grid.querySelector(':scope > .product-aside');
      var images = grid.querySelector(':scope > .product-images');
      if (!aside || !images || !aside.querySelector('.purchase-box')) return;

      function columnPart(column, selector) {
        var node = column.querySelector(selector);
        if (!node) return null;
        while (node.parentElement !== column) {
          node = node.parentElement;
          if (!node) return null;
        }
        return node;
      }

      var finder = columnPart(aside, '[data-bioss-product-distributor-finder]');
      var promo = columnPart(aside, '.pf-cf83f501a465-10_');
      var recommendations = columnPart(aside, '.pf-8846aeb6c091-7_');
      var citations = columnPart(images, '[data-bioss-citeab-section]');
      var citationLink = columnPart(aside, '.bioss-product-page-citations-cta');
      var guarantee = columnPart(aside, '.guarantee');
      var entries = [
        { node: aside, name: 'purchase' },
        { node: images, name: 'photos-description' },
        { node: finder, name: 'international' },
        { node: promo, name: 'promo' },
        { node: recommendations, name: 'recommendations' },
        { node: citationLink, name: 'citation-link' },
        { node: citations, name: 'citations' },
        { node: guarantee, name: 'guarantee' }
      ].filter(function (entry) { return entry.node; });

      entries.forEach(function (entry) {
        entry.anchor = document.createComment('bioss-product-order-' + entry.name);
        entry.node.parentNode.insertBefore(entry.anchor, entry.node);
      });

      var citationGroup = document.createElement('div');
      citationGroup.setAttribute('data-bioss-product-part', 'citations');
      var active = false;

      function sync() {
        if (mobile.matches === active) return;
        if (mobile.matches) {
          entries.forEach(function (entry) {
            if (entry.name === 'citation-link' || entry.name === 'citations') {
              if (!citationGroup.parentNode) grid.appendChild(citationGroup);
              citationGroup.appendChild(entry.node);
            } else {
              entry.node.setAttribute('data-bioss-product-part', entry.name);
              grid.appendChild(entry.node);
            }
          });
          grid.setAttribute('data-bioss-mobile-product-order', '');
        } else {
          entries.forEach(function (entry) {
            entry.anchor.parentNode.insertBefore(entry.node, entry.anchor.nextSibling);
            entry.node.removeAttribute('data-bioss-product-part');
          });
          citationGroup.remove();
          grid.removeAttribute('data-bioss-mobile-product-order');
        }
        active = mobile.matches;
        window.dispatchEvent(new Event('resize'));
      }

      grid.dataset.biossProductOrderReady = 'true';
      mobile.addEventListener('change', sync);
      sync();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
